import apiFetch from '../apiFetch'

export default function (values, token, signal) {
  return apiFetch({endPoint: `Dilucion/prepararMaquinaDilucion`, method: 'POST', body: values, token: token, signal: signal})
}
